import { useEffect, useMemo, useState } from "react";

import { ITab, Tab } from "./Tab";
import { Catalogos } from "../../services/Catalogos";
import { TabIOC } from "../ioc/TabIOC";
import { TabICV } from "../icv/TabICV";
import { TabIFRF } from "../ifrf/TabIFRF";
import { ICVService } from "../../services/ICVService";



export enum PasoEnum {
	PASO_1,
	PASO_2,
	PASO_3,
	PASO_4,
	PASO_BODY,
}


export const MainTabs = () => {

	useMemo( () => Catalogos.init(), [])

	const [ pasosArray, setPasosArray ] = useState<ITab[]>( [] );
	const [ tab, setTab ] = useState<PasoEnum>();
	const [ tabAnt, setTabAnt ] = useState<PasoEnum>();

	const [ urlPdf, setuUrlPdf ] = useState("");
	const [ visiblePDF, setvisiblePDF ] = useState(false);

	const [ verImagen, setVerImagen ] = useState(true);

	const activeTab = (pasoEnum:PasoEnum) => {
		
		if( pasoEnum === tab ) return ;
		
		
		switch (pasoEnum) {
			case PasoEnum.PASO_1:
				setPasosArray([
					{ paso: PasoEnum.PASO_1, titulo:'Indicadores de Otorgamiento de Crédito', order:0, orderMd:0, pasoActivo:true, fn:activeTab},
					{ paso: PasoEnum.PASO_2, titulo:'Indicadores de Flujos de Recaudación Fiscal', order:2, orderMd:1, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_3, titulo:'Índices de Calidad de la Vivienda', order:3, orderMd:2, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_4, titulo:'Manual de Usuario', order:4, orderMd:3, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_BODY, titulo:'Body', order:1, orderMd:4, pasoActivo:false, fn:activeTab}
				]);
				break;
			case PasoEnum.PASO_2:
				setPasosArray([
					{ paso: PasoEnum.PASO_1, titulo:'Indicadores de Otorgamiento de Crédito', order:0, orderMd:0, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_2, titulo:'Indicadores de Flujos de Recaudación Fiscal', order:1, orderMd:1, pasoActivo:true, fn:activeTab},
					{ paso: PasoEnum.PASO_3, titulo:'Índices de Calidad de la Vivienda', order:3, orderMd:3, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_4, titulo:'Manual de Usuario', order:4, orderMd:3, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_BODY, titulo:'Body', order:2, orderMd:4, pasoActivo:false, fn:activeTab}
				]);
				break;
			case PasoEnum.PASO_3:
				setPasosArray([
					{ paso: PasoEnum.PASO_1, titulo:'Indicadores de Otorgamiento de Crédito', order:0, orderMd:0, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_2, titulo:'Indicadores de Flujos de Recaudación Fiscal', order:1, orderMd:1, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_3, titulo:'Índices de Calidad de la Vivienda', order:2, orderMd:3, pasoActivo:true, fn:activeTab},
					{ paso: PasoEnum.PASO_4, titulo:'Manual de Usuario', order:4, orderMd:3, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_BODY, titulo:'Body', order:3, orderMd:4, pasoActivo:false, fn:activeTab}
				]);
				break;
			case PasoEnum.PASO_4:
				setPasosArray([	
					{ paso: PasoEnum.PASO_1, titulo:'Indicadores de Otorgamiento de Crédito', order:0, orderMd:0, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_2, titulo:'Indicadores de Flujos de Recaudación Fiscal', order:1, orderMd:1, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_3, titulo:'Índices de Calidad de la Vivienda', order:2, orderMd:2, pasoActivo:false, fn:activeTab},
					{ paso: PasoEnum.PASO_4, titulo:'Manual de Usuario', order:3, orderMd:3, pasoActivo:true, fn:activeTab},
					{ paso: PasoEnum.PASO_BODY, titulo:'Body', order:4, orderMd:4, pasoActivo:false, fn:activeTab}
				]);
				break;
		
			default:
				//Catalogos.init();
				setTimeout( () => {
					setVerImagen(false);
					activeTab(PasoEnum.PASO_1)
					}, 1000);
				break;
		}
		
		setTab(pasoEnum);
	}


	useEffect(() => {
		
		//Tab visitado anteriormente
		setTabAnt(tab);
		
		//Obtiene url del pdf
		consultaUrlPDF();
		
		
		
        /* cuerpo cuando se monta */
        
        if(tabAnt===undefined)
        	activeTab(PasoEnum.PASO_BODY);
        	
        	
		return () => {
            /* cuerpo cuando se desmonta */            
        }
        
    }, [tab]);
    
    
    
    const consultaUrlPDF = async () => {
		
		//Si es el Tab de ayuda
		if(tab===3){
			
			setvisiblePDF(true);
			
			const icvServ = new ICVService() ;
			
			let params = "tipoCubo=";
			
			switch (tabAnt) {
				case 0:
					params+= "IOC";
					break;
					
				case 1:
					params+= "IFRF";
					break;
					
				case 2:
					params+= "ICV";
					break;
					
				default:
					break;
			}
			
			
			
			await icvServ.consultaUrlPDF(params)
	            .then( (data: XMLHttpRequestResponseType) =>{
	                
	                if( data ) {						
					   
					   setuUrlPdf(data);
					   
	                } else {
	                    console.error("No se pudo obtener una respuesta")
	                   
	                }
	            }).catch((e: any) => {
	                
        	});	
		}else{
			
			setvisiblePDF(false);
		}
		
		
	}
		
	return (
		<div className="container">
		<section className="row">
			<div className="col-12 mt-5 mb-5">
					<div className="row">
							{
								pasosArray.map((item,i)=>{
									const {paso, titulo, order, orderMd, pasoActivo, fn}=item;
									
									if(paso === PasoEnum.PASO_BODY ) {
																			
										return <div className={'col-12 pl-0 pr-0 order-'+order+' order-md-'+orderMd+''} key={i} >
											<div className="card sombra paso pt-0">
												<div className="row m-4">
													
													<div id="tab1" className="col-12">
														{
														tab === PasoEnum.PASO_1 && <TabIOC />
														}
													</div>
													<div id="tab2" className="col-12">
														{
															tab === PasoEnum.PASO_2 && <TabIFRF />
														}
													</div>
													<div id="tab3" className="col-12">
														{
														tab === PasoEnum.PASO_3 && <TabICV />
														}
													</div>
													<div id="tab4Content" className="col-12">
														{
															visiblePDF &&
															<embed className="pdf-view" src={urlPdf}  />
														}
													</div>
												</div>
											</div>
										</div>
									} else {
										//console.log("Else  Paso: " + paso +  "  Titulo: " + titulo + "  Order: " + order + "   OrderMD: " + orderMd + "   PasoActivo: " + pasoActivo );
										
										return <Tab paso={paso} titulo={titulo} order={order} orderMd={orderMd} pasoActivo={pasoActivo} fn={fn} key={i} />	;
									}
									
								})

							}
							{
								verImagen && <div className={'col-12 pl-0 pr-0 '}>
												<div className="card sombra paso pt-0">
													<div className="row m-4">
														<div id="tab1" className="col-12 text-center">
															<img alt="" src={ process.env.REACT_APP_CONTEXT_PATH + '/images/loading.gif'} className="imgGif" />
														</div>
													</div>
												</div>
											</div>
							}
							{/*
								!verImagen && !Catalogos.loaded &&	<div className={'col-12 pl-0 pr-0 '}>
																		<div className="card sombra paso pt-0">
																			<div className="row m-4">
																				<div id="tab1" className="col-12 text-center">
																					<label>Por el momento el servicio no se encuentra disponible.</label>
																				</div>
																			</div>
																		</div>
																	</div>
								
						*/}
						
					</div>
			</div>
		</section>
		</div>
	);
}